import React from 'react';
import { connect } from 'react-redux'
import { withCookies } from 'react-cookie';
import { AccordionStatus } from './../../constants/actionType';
import { updateSCcustomEvent,tempSCData} from './../../service/dtmTag';
import {invokeTouchCommerce} from './../../service/aimsChat';
import PromoContent from './../../constants/promoContent';
import { InHomeUtils } from './../../util/inhomeUtils';
import {catchJSException} from './../../service/logService';
import {prefetchPlansForFailedCase,setAccordionStatus} from './../../action/buildProduct'
import { tempVzdlSCData,updateVzdlSCCustomEvent } from '../../service/vzdl';
import { Title } from '@vds/typography';

class accordionTitle extends React.PureComponent{
  handleKeyDown = (e, name,title,omniTitle) => {
    //keyboard accessibility for accordion using space bar and enter keys
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.openAccordion(e, name,title,omniTitle);
    }
  }
  openAccordion = (e,name,title,omniTitle="") => {
    try{
      if (InHomeUtils.isNotNull(name)) {    
        invokeTouchCommerce(name);
        setAccordionStatus(name, this.props.dispatch, this.props.isAccordionOpen)
        if(!this.props.isAccordionOpen){        
          let val = this.props.isDoFlow?"do accord":"byob";
          tempSCData.pageName=val;
          if ((name.indexOf("internet") > -1) || (name.indexOf("datasub") > -1)) {
            // val = val + "| internet"
            val = val + "| internet"+"| "+ title;
          }
          else if (name.indexOf("tv") > -1) {
            val = val + "| tv"+"| "+ title;
          }
          else if (name.indexOf("phone") > -1) {
            if(title === "Call more countries & destinations"){
              title = "call more countries";
            }
            val = val + "| phone"+"| "+ title;
          }
          else if (name.indexOf("streamingserv_acc") > -1) {
            val = val + "| stream services-devices"
          }
          else if (name.indexOf("streamingserv_plan") > -1) {
            val = val + "| stream services-devices| pick service"
          }
          else if (name.indexOf("streamingdevcnt_plan") > -1) {
            val = val + "| stream services-devices| add devices-nums"
          }
          else if (name.indexOf("contract") > -1) {
            val = val + "| contract"
          }
          else if (name.indexOf("internationalchannel") > -1) {
            val = val + "|  tv| add international channel"
          }
          else if (name.indexOf("flash") > -1) {
            val = val + "| internet| black friday "
          }
          else if (name.indexOf("splOffer") > -1) {
            val = val + "| internet| select your int promo offer"
          }
          else if (name.indexOf("emergency_services")>-1) {
            val = val + "| phone| Emergency Services"
          }
          tempSCData.detailPageName = val // for DOflows/Prepaid need to uodate these values later 
          if (InHomeUtils.isNotNull(omniTitle) && omniTitle !== "") {
            let title = "";
            if (omniTitle === "Please select internet") {
              title = "Add Internet"
            }
            else if (omniTitle === "Please select router") {
              title = "Add router";
            }
            else if (omniTitle === "How many TVs") {
              title = "Add settop box ";
            }
            else if (omniTitle === "Pick your recording service") {
              title = "Add recording service";
            }
            else if (omniTitle === "Please pick your Live TV option") {
              title = "Add Live TV";
            }
            else if (omniTitle === "Pick your voice option") {
              title = "Add phone";
            }
            else if (omniTitle.indexOf("Emergency services")>-1){
              title = "Emergency Services";
            }
            else{
              title = omniTitle;
            }
            tempVzdlSCData.detail = title;
          }
          else{
            if (name.indexOf("internet") > -1 || name.indexOf("tv") > -1 || name.indexOf("phone") > -1) {
              tempVzdlSCData.detail = val.split("|") && val.split("|").length>2?val.split("|")[2].trim():"";
            }
            else if(name.indexOf("flash") > -1 ){
              tempVzdlSCData.detail = "internet - black friday";
            }else if (name.indexOf("splOffer") > -1) {
              tempVzdlSCData.detail = "Choose your offer";
            }
            else{
              tempVzdlSCData.detail = val.split("|")[1].trim();
            }
          }
          
          if (this.props.flowType === "MV") {
            if (this.props.cust_opt === "NONSEAMLESS" && this.props.isFCPflow && !this.props.isFcpInProfile){
              tempSCData.flowName = "prospect accord move| mix match";
              tempVzdlSCData.flowName = "accord move + mix match";
            }
            else if (this.props.cust_opt === "SEAMLESS" && this.props.isFCPflow && !this.props.isFcpInProfile){
              tempSCData.flowName = "prospect accord seamless move";
              tempVzdlSCData.flowName = "prospect accord + seamless move";
            }
            else if (this.props.cust_opt === "SEAMLESS" && this.props.isFCPflow && this.props.isFcpInProfile){
              tempSCData.flowName = "prospect accord seamless move| mix match";
              tempVzdlSCData.flowName = "accord seamless move + mix match";
            }
            else if (this.props.isFCPflow && this.props.cust_opt == null && this.props.isFcpInProfile){
              tempSCData.flowName = "prospect accord move| mix match";
              tempVzdlSCData.flowName = "accord move + mix match";
            }
            else{
              tempSCData.flowName = "prospect accord move";
              tempVzdlSCData.flowName = "accord move";
            }
            tempSCData.customerCategory = "^Moves^";
            updateSCcustomEvent("accordionOpenMoves", "ddAddToCartEvent", "detailPageName,pageName");
            updateVzdlSCCustomEvent("accordionOpenMoves","pageViewOmni","detail");
          }
          else{

            if(this.props.flowType === "SUPP"){
              tempSCData.contentChannel="/vz/residential/myverizon/whats+next/fios/acrd supp order";
              updateSCcustomEvent("accordionOpen", "ddAddToCartEvent", "detailPageName,pageName,contentChannel");
              updateVzdlSCCustomEvent("accordionOpen","pageViewOmni","detail");
            }
            else{
              updateSCcustomEvent("accordionOpen", "ddAddToCartEvent", "detailPageName,pageName");
              updateVzdlSCCustomEvent("accordionOpen","pageViewOmni","detail");
            }
          }
            
        }
        this.checkProductsForLBO(name);
      }
    }
    catch(ex)
    {    
     catchJSException('BuildProduct',this.props.visitId,'accordionTitle-openAccordion',ex);
    }    
  }

  checkProductsForLBO = (accName) => {
    let addlParam = {
      zip: this.props.zip,
      tarCode: this.props.tarcode,
      channelLineUpTvPackages: this.props.buildProduct.masterpackageview,
      isDoflow: false,
      couponFlowType: null,
      flowType: '',
      reAttemptCount: 2
    }
    let suppHasSlingTV = this.props.suppHasSlingTV ;
    if (accName.toLowerCase().indexOf('internet_accor') > -1 && !this.props.buildProduct.internet.isAccordionOpen && this.props.buildProduct.internet.isSubAccordionOpen && this.props.buildProduct.internet.m2mPlans.length === 0) {
      prefetchPlansForFailedCase(this.props.dispatch, this.props.visitId, addlParam, 'data');
    } else if (!InHomeUtils.isNotNull(suppHasSlingTV) && accName.toLowerCase().indexOf('tv_accor') > -1 && !this.props.buildProduct.tv.isAccordionOpen && this.props.buildProduct.tv.isSubAccordionOpen && this.props.buildProduct.tv.m2mPlans.length === 0) {
      prefetchPlansForFailedCase(this.props.dispatch, this.props.visitId, addlParam, 'video');
    }
    else if (accName.toLowerCase().indexOf('phone_accor') > -1 && !this.props.buildProduct.voice.isAccordionOpen && this.props.buildProduct.voice.isSubAccordionOpen && this.props.buildProduct.voice.plans.length === 0) {
      prefetchPlansForFailedCase(this.props.dispatch, this.props.visitId, addlParam, 'voice');
    }
  }

  render() {
    let actionStatus = '',headerStatusClass='required_ribbon normal-weight';
    if (this.props.status === AccordionStatus.required) {
      actionStatus = <span className="m_required">
         <Title viewport="mobile"  primitive="span" color="#cd040b">
          Required
        </Title>
      </span>;
      headerStatusClass='required_ribbon normal-weight required';
    }
    else if (this.props.status === AccordionStatus.added) {
      headerStatusClass="required_ribbon normal-weight added";
      actionStatus = <span className="m_added">
        <Title viewport="mobile"  primitive="span" color="#00AD3E">
          Added
        </Title>
      </span>;
    }
    else if (this.props.status === AccordionStatus.completed) {
      headerStatusClass="required_ribbon normal-weight headingstatuscompleted";
      actionStatus = <span className="m_headingadded">
        <Title viewport="mobile"  primitive="span" color="#00AD3E">
          Added
        </Title>
      </span>;
    }
    else if (this.props.status === AccordionStatus.actionRequired) {
      actionStatus = <span className="m_actionrequired">
        <Title viewport="mobile" primitive="span" color="#ed7000">
          Action Required
        </Title>
      </span>;
      headerStatusClass="required_ribbon normal-weight headingstatusrequired";
    }
    else if (this.props.status === AccordionStatus.reviewRequired) {
      actionStatus = <span className="m_reviewrequired">
        <Title viewport="mobile" primitive="span" color="#ed7000">
          Review Required
        </Title>
      </span>;
    }
    else if (this.props.status === AccordionStatus.optional) {
      actionStatus = <span className="t_optional">
        <Title viewport="mobile" primitive="span" color="#747676">
          Optional
        </Title>
      </span>;
      headerStatusClass='required_ribbon normal-weight headingoptional'
    } 
    
    let promoInfo = '';
    let isHidePromo = false;
    if(InHomeUtils.isNotNull(this.props.isHidePromo) && this.props.isHidePromo === 'true'){
      isHidePromo = true;
    }    
    if(!isHidePromo){
      let isCartData = (InHomeUtils.isNotNull(this.props.cart) && InHomeUtils.isNotNull(this.props.cart.cartData) && this.props.cart.cartData.length > 0) ? true : false;
    
      if(isCartData && InHomeUtils.isNotNull(this.props.locationId) && this.props.locationId !== '') {
          promoInfo = <PromoContent locationId={this.props.locationId} cartData={this.props.cart.cartData[0]} buildProductContent={this.props.buildProduct}/>;
      }
    }
    
    let isProgressBarPresent = this.props?.lqState?.runtimeKey?.displayProgressBar === 'Y' && window.showProgressBar === 'Y' && this.props.buildProduct.isProgressBarDisplayed ? true : false
    let template = (    
      <div id={this.props.name} ref={(e) => this.props.inputelementRef[this.props.name] = e} onKeyDown={(e) => this.handleKeyDown(e, this.props.name,this.props.title,this.props.titleOmniName)} onClick={(e) => this.openAccordion(e, this.props.name,this.props.title,this.props.titleOmniName)} className={(this.props.isAccordionOpenRequired === false ? 'accordion_blocks-reveal' : (this.props.isAccordionOpen ? 'accordion_blocks-reveal open' : 'accordion_blocks-reveal close'))} 
                      data-reveal-toggle-class="close open" data-internet-options="" data-reveal-group="OrderingAccordion" style={{borderTop:isProgressBarPresent && '1.5px solid black'}}>
        <div className="accord-acc-wrapper pointer" tabIndex={this.props.isAccordionDisabled ? "-1" : "0"} role="button" aria-hidden={this.props.isAccordionDisabled}  aria-expanded={this.props.isAccordionOpen}>
          <div className={`columns ${actionStatus !== `` ?  `tiny-6 small-6 medium-6` : `tiny-12 small-12 medium-12`} padding-horiz-zero headline-wrapper`}>
            <div className="headline-content HdrInternet padding-left-tiny text-black" id="SelectedInternet">
            <Title viewport="mobile" primitive={this.props.primitive? this.props.primitive :"h3"} color="black">
              {this.props.title?.toString()?.replace('4.0','')}
            </Title>
              {promoInfo}
            </div>
          </div>
          <div className="inline-block vert-top text-right right">
            <div className={headerStatusClass} id="internetstatus" >
              {actionStatus}             
            </div>
          </div>
        </div>
      </div>
      
    );

    return (
      <React.Fragment>
        {template}
      </React.Fragment>
    );
  }

}; 
const mapStateToProps = (state) => {
  return {
    buildProduct: state.buildProduct,
    visitId: state.app.visitId,
    cart: state.cart,
    save: state.save,
    flowType: state.app.flowType,
    moveExp: state.moveExp.moveLandingExp,
    isFCPflow: state.loopQual.isFCPflow,
    isDoFlow: state.loopQual.doFlowDetails.isDoFlow,
    zip: state.loopQual.selectedState ? state.loopQual.selectedState.zip : '',
    tarCode: state.loopQual.selectedState ? state.loopQual.lqResponse.tarcode : '',
    cust_opt: state.moveExp.cust_opt,
    isFcpInProfile: state.loopQual.isFcpInProfile,
    lqState: state.loopQual
  }
}
export default withCookies(connect(
    mapStateToProps,
)(accordionTitle));